import { isFulfilled } from '@reduxjs/toolkit'
import { FC, useRef } from 'react'
import AsyncSelect from 'react-select/async'
import { ActionMeta, ValueType } from 'react-select'

import { TAttachmentFacebookVideoTag } from '../../../../models/post'
import { useDispatch } from '../../../../store'
import { addFacebookVideoTagAction } from '../../../../store/managePost/slice'
import { getFacebooVideoTagsThunk } from '../../../../store/managePost/thunks'

import './UI.scss'
import { SelectOption } from '../../../../models/form'

type VideoTagMultiselectProps = {
  value: TAttachmentFacebookVideoTag[]
}

type TFacebookContentTag = {
  audience_size: number
  description: string
  disambiguation_category: string
  id: string
  name: string
  path: string[]
  topic: string
}

const VideoTagMultiselect: FC<VideoTagMultiselectProps> = ({ value }) => {
  const dispatch = useDispatch()
  const refTimeoutToGetTags = useRef<null | NodeJS.Timeout>(null)

  const transformDataToSelectOption = (
    data: (TFacebookContentTag | TAttachmentFacebookVideoTag)[]
  ) => data.map((tag) => ({ value: tag.id, label: tag.name }))

  const getVideoTags = async (query: string) => {
    return new Promise((resolve) => {
      if (query.length > 1) {
        const timeoutToGetTags = setTimeout(async () => {
          const getFbTagsResponse = await dispatch(getFacebooVideoTagsThunk(query))
          if (isFulfilled(getFbTagsResponse)) {
            const transformedTags = transformDataToSelectOption(getFbTagsResponse.payload)
            resolve(transformedTags)
          }
          resolve([])
        }, 500)
        if (refTimeoutToGetTags.current) clearTimeout(refTimeoutToGetTags.current)
        refTimeoutToGetTags.current = timeoutToGetTags
      }
    })
  }

  const onChange = (values: ValueType<SelectOption, true>, action: ActionMeta<SelectOption>) => {
    if (values)
      dispatch(addFacebookVideoTagAction(values.map((tag) => ({ name: tag.label, id: tag.value }))))
  }

  return (
    <div className='video-tag-multiselect'>
      <AsyncSelect
        defaultValue={transformDataToSelectOption(value)}
        components={{
          IndicatorSeparator: () => null,
          IndicatorsContainer: () => null
        }}
        placeholder='Keywords to help people find your video'
        loadOptions={getVideoTags}
        onChange={onChange}
        classNamePrefix='video-tag-multiselect'
        isSearchable={true}
        // @ts-ignore
        isMulti={true}
      />
    </div>
  )
}

export default VideoTagMultiselect
